import {Mapper} from '@s-ui/domain'

const EVENT_NAME_NEWS_DETAIL = 'editorial_news_detail'
const EVENT_NAME_VIDEOS_DETAIL = 'editorial_videos_detail'
const EVENT_NAME_TESTS_DETAIL = 'editorial_tests_detail'
const EVENT_NAME_NEWNESS_DETAIL = 'editorial_newness_detail'
const EVENT_NAME_COMPARISONS_DETAIL = 'editorial_comparisons_detail'

export default class AdvertisingNewsDetailValueObjectMapper extends Mapper {
  constructor({config, valueObjectFactory}) {
    super({config, valueObjectFactory})
    this._config = config
    this._culture = this._config.get('DEFAULT_CULTURE')
    this._lang = this._config.get('URL_CULTURES_MAP')[this._culture]
    this._valueObjectFactory = valueObjectFactory
  }

  _getEventName = ({category}) => {
    let eventName = EVENT_NAME_NEWS_DETAIL

    if (category) {
      const categoryId = this._getNewsCategoryId({category})

      switch (categoryId) {
        case 'tests':
          eventName = EVENT_NAME_TESTS_DETAIL
          break
        case 'newness':
          eventName = EVENT_NAME_NEWNESS_DETAIL
          break
        case 'comparisons':
          eventName = EVENT_NAME_COMPARISONS_DETAIL
          break
        case 'videos':
          eventName = EVENT_NAME_VIDEOS_DETAIL
          break
        default:
          eventName = EVENT_NAME_NEWS_DETAIL
          break
      }
    }

    return eventName
  }

  _getNewsCategoryId = ({category}) =>
    this._config.get('editorial').newsCategories.find(({path}) => category === path)?.id

  _getLabels = ({tags = []}) => tags.join('-')

  map = ({category, make = {}, model, tags}) => {
    const trackingConfig = this._config.get('tracking')
    const adsNamePage = trackingConfig.ADS_NAME_PAGE_NEWS_DETAIL

    return this._valueObjectFactory({
      ads_name_page: adsNamePage,
      event_name: this._getEventName({category}),
      labels: this._getLabels({tags}),
      country_code: this._lang,
      site: this._config.get('TENANT'),
      brand: make.name,
      brand_id: make.id,
      model: model.name,
      model_id: model.id
    })
  }
}
